import { useShoppingCartContext } from '@ravago/shared/page-elements-radiance/context/shopping-cart-context';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Button } from '@ravago/shared/radiance/components/button/components/Button/Button';
import { Icon } from '@ravago/shared/radiance/components/icon/components/Icon/Icon';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

const AddToShoppingCartDuplicateInfo = () => {
  const translate = useTranslations();
  const { state, addToCart, isAddingToCart, resetCartValidation } = useShoppingCartContext();
  const { existingItem, duplicateCartItem } = state;

  const addToShoppingCart = () => {
    if (!duplicateCartItem || !existingItem) return;
    addToCart(duplicateCartItem.source, duplicateCartItem.orderableProduct, duplicateCartItem.packaging, duplicateCartItem.quantity, true);
  };

  return (
    <Box direction="column" gap="lg">
      <Box gap="md">
        <Icon icon="info" />
        <Typography variant="heading-4">{translate('shopping-cart.validation.quantity-warning')}</Typography>
      </Box>
      {duplicateCartItem && existingItem && (
        <Typography>
          {translate('shopping-cart.validation.quantity-override-warning', {
            productName: duplicateCartItem.orderableProduct.description,
            existingQuantity: `${existingItem.quantity.amount} ${existingItem.quantity.unitOfMeasure}`,
            nextQuantity: `${duplicateCartItem.quantity.amount} ${duplicateCartItem.quantity.unitOfMeasure}`
          })}
        </Typography>
      )}
      <Box direction="column" gap="md">
        <Button disabled={isAddingToCart} onClick={addToShoppingCart}>{translate('shopping-cart.validation.continue')}</Button>
        <Button variant="secondary" onClick={resetCartValidation}>
          {translate('shopping-cart.validation.modal-close')}
        </Button>
      </Box>
    </Box>
  );
};

export default AddToShoppingCartDuplicateInfo;
